import { actionCopyEnUs } from "./actionCopy";
import { listCopyEnUs } from "./listCopy";

export const patientsCopyEnUs = {
    patients: "Patients",
    navPatientsDescription: "Manage your patients all from one place.",
    patientFallback: "Patient",
    action: "Action",
    trackerEntry: "Tracker Entry",
    patientsError: "Patients Error",
    error: "Error",
    tabActive: "Active",
    tabPending: "Pending",
    tabInactive: "Inactive",
    search: actionCopyEnUs.search,
    searchPatientsAria: "Search patients",
    searchForPatient: "Search for a patient",
    searchDescription: "Search by name, email, date of birth, hospital number, or diary name",
    searchPlaceholder: "Search by name, email, DOB, hospital number...",
    noResultsFound: "No results found",
    trySearchingHint: "Try searching by name, email, date of birth, or hospital number",
    enterSearchTerm: "Enter a search term to find patients",
    loadingDiaries: "Loading diaries...",
    errorLoadingDiaries: (message) => `Error loading diaries: ${message}`,
    unknownPatient: "Unknown Patient",
    dateOfBirthLabel: "Date of Birth",
    noDiariesOnPage: "No diaries on this page",
    showingDiaries: (start, end, total) => `Showing diaries ${start} to ${end} of ${total}`,
    patientsPerPage: "Patients per page",
    emptyFirstPatientTitle: "Invite your first patient",
    emptyFirstPatientDescription:
        "Choose a diary setup, review the details, then send an invite. Their progress will appear here.",
    emptyFirstPatientCta: "Add your first diary",
    emptyFirstPatientHelpLink: "How do I invite a patient?",
    emptyTabTitle: (tabLabel) => `No ${tabLabel.toLowerCase()} diaries`,
    emptyTabDescription: "Diaries in other tabs are still available. Switch tabs, or invite another patient.",
    notDefined: "Not Defined",
    columnDiaryStatus: "Diary Status",
    columnStartDate: "Start Date",
    columnPatientName: "Patient Name",
    columnOrganisation: listCopyEnUs.organisation,
    columnLabels: listCopyEnUs.labels,
    columnDateOfBirth: listCopyEnUs.dateOfBirth,
    columnHospitalNumber: "Hospital Number",
    columnRead: "Reviewed",
    filters: actionCopyEnUs.filters,
    filterDiariesAria: "Filter diaries",
    viewSettings: "View settings",
    viewSettingsDescription:
        "Choose diary scope, status, shared clinicians, labels, and organization filters for this list.",
    sharedWithClinicians: "Shared with clinicians",
    diaryStatus: "Diary status",
    selectStatuses: "Select statuses",
    labels: listCopyEnUs.labels,
    organisation: listCopyEnUs.organisation,
    save: actionCopyEnUs.save,
    apply: actionCopyEnUs.apply,
    sortDiariesTitle: "Sort diaries",
    sortDiariesDescription:
        "Choose the field and order for this list. Sorting applies to every diary in the current tab, not only this page.",
    diaryScope: "Diary scope",
    directAccess: "Direct Access",
    allDiariesInOrganisation: "All diaries in my organization",
    selectClinicians: "Select clinicians",
    selectLabels: "Select labels",
    clearFilters: "Clear filters",
    selectOrganisations: "Select organizations",
    sortDiariesAria: "Sort diaries",
    sortBy: "Sort by",
    order: "Order",
    sortAscending: "Ascending",
    sortDescending: "Descending",
    sortState: "State",
    sortStartDate: "Start date",
    sortFirstName: "First name",
    sortLastName: "Last name",
    sortDateOfBirth: "Date of birth",
    sortHospitalNumber: "Hospital number",
    read: "Reviewed",
    unread: "Not reviewed",
    noDiarySelected: "No Diary Selected",
    refreshDiary: "Refresh Diary",
    noDiaryFound: "No diary found.",
    diaryCouldNotLoad: "Diary could not be loaded.",
    profileCouldNotLoad: "Profile could not be loaded.",
    diaryDetails: "Diary Details",
    patientDetails: "Patient Details",
    unknownState: "Unknown State",
    edit: actionCopyEnUs.edit,
    done: actionCopyEnUs.done,
    none: actionCopyEnUs.none,
    contact: "Contact",
    noContactPerson: "No contact person",
    lastEntry: (relative) => `Last entry ${relative}`,
    diaryOrganisation: "Diary Organization",
    organisationAndContact: "Organization & contact",
    editCareDetails: "Edit care details",
    labelsStudyTrial: "Labels (Study / Trial)",
    contactName: "Contact Name",
    contactLabel: (name) => `Contact: ${name}`,
    nameLabel: "Name",
    emailLabel: "Email",
    openLink: "Open link",
    dateRangeToNow: (start) => `${start} to now`,
    dateRangeTo: (start, end) => `${start} to ${end}`,
    informationToComplete: "Information to complete",
    clinicianTasks: (entryCount, formCount) =>
        `You have ${entryCount === 1 ? "1 entry due" : `${entryCount} entries due`} across ${
            formCount === 1 ? "1 form for the team to complete." : `${formCount} forms for the team to complete.`
        }`,
    completeNextForm: "Complete next form",
    completeForm: (title) => `Complete ${title}`,
    questionnaire: "Questionnaire",
    more: actionCopyEnUs.more,
    moreActions: "More actions",
    moreActionsAria: "More actions",
    printDiary: "Print diary",
    shareDiary: "Share diary",
    openFullScreen: "Open full screen",
    messageHistory: "Message History",
    deleteDiary: "Delete diary",
    deleteDiaryTitle: "Delete Diary",
    deleteDiaryDescription: "Are you sure you want to delete this diary?",
    cancel: actionCopyEnUs.cancel,
    delete: actionCopyEnUs.delete,
    updateDiary: "Update Diary",
    addToDiary: "Add to Diary",
    addEvent: "Add event",
    addConsent: "Add consent",
    addQuestionnaire: "Add questionnaire",
    addFromTemplate: "Add from template",
    addEventDescription: "Add a procedure and link it to an existing date, or start a new one.",
    addConsentDescription: "Attach a consent to a procedure, or add one with its own date.",
    addQuestionnaireDescription: "Add a questionnaire and link it to an existing date, or start a new one.",
    addFromTemplateDescription: "Apply a saved template to this diary.",
    addConsentTitle: "Add consent",
    addConsentDescriptionLong: "Choose a procedure, or add a consent with its own date.",
    selectProcedureDate: "Procedure",
    notForAnEvent: "Not for an event",
    consentDate: "Date",
    noProcedureDatesForConsent: "Add a procedure first.",
    addEventFirst: "Add event first",
    selectConsent: "Consent",
    selectConsentHelp: "Choose a published consent to add to this diary.",
    noPublishedConsents: "No published consents are available. An admin can publish one in the consent builder.",
    consentRoles: "Who must sign",
    consentRolesHelp: "The selected people will be asked to sign this consent.",
    saveConsent: "Add consent",
    savingConsent: "Adding consent…",
    existingDateGroup: "Did this happen on the same date as",
    newDate: "Not one of the dates above",
    newDateHelp: "",
    pickExistingDateHelp: "",
    markAsReviewed: "Mark as Reviewed",
    endDiary: "End Diary",
    reinstate: "Reinstate",
    contactPatient: "Contact Patient",
    endDiaryTitle: "End Diary",
    endDiaryNotifyQuestion: "Would you like to notify the patient?",
    justEndDiary: "Just end diary",
    endDiaryAndNotify: "End diary and notify patient",
    markReviewedTitle: "Mark as Reviewed",
    markReviewedNotifyQuestion: "Would you like to notify the patient that their diary has been reviewed?",
    justMarkReviewed: "Just mark reviewed",
    notifyPatient: "Notify patient",
    from: "From",
    to: "To",
    subject: "Subject",
    emailBody: "Email Body",
    send: actionCopyEnUs.send,
    sending: actionCopyEnUs.sending,
    emailSentSuccess: "Email sent successfully",
    emailSentDescription: "The patient has been notified",
    emailSendFailed: "Failed to send email",
    seeYourPatients: "See your Patients",
    seeYourPatientsDescription: "Monitor your patients' progress and manage their diaries",
    goToPatients: "Go to Patients",
    goingToPatients: "Going to Patients...",
    reliableEmailWarning: "For reliable delivery, we recommend Gmail, Outlook, or iCloud.",
    entryRecordedTitle: "Entry Recorded Successfully",
    entryRecordedPending: (count) =>
        `There ${count === 1 ? "is" : "are"} ${count} more ${count === 1 ? "entry" : "entries"} pending for this patient. Please ensure all required assessments are completed.`,
    entryRecordedComplete:
        "All required entries for this patient have been completed. The patient's record is now up to date.",
    continueToNextEntry: "Continue to Next Entry",
    returnToPatient: "Return to Patient",
    loadingTemplates: "Loading templates…",
    addToDiaryTitle: "Add to diary",
    addToDiaryDescription: "Add a procedure, consent, or questionnaire, or start from a template.",
    addManually: "Add manually",
    addManuallyDescription: "Enter procedure and questionnaire details step by step without using a template.",
    chooseTemplate: "Choose a template",
    chooseTemplateDescription:
        "Select a saved template to pre-fill procedure and questionnaire details for this diary.",
    reviewTemplate: "Review Template",
    reviewTemplateDescription: "Confirm the details below before adding to this diary.",
    confirmAndContinue: "Confirm & Continue",
    notifyPatientTitle: "Notify patient?",
    intervention: "Intervention",
    openingTemplateProcedure: "Opening your template procedure…",
    existingQuestionnaires: "Existing Questionnaires",
    continueWithAllQuestionnaires: "Continue with All Questionnaires",
    upcomingEntries: "Upcoming entries",
    noUpcomingEntries: "No upcoming entries.",
    moreEntriesSummary: (count) => `... ${count} more entries ...`,
    unlocks: (date) => `Unlocks ${date}`,
    diaryEnded: "Diary ended",
    failedToEndDiary: "Failed to end diary",
    tableSettingsSaved: "Table settings saved",
    diaryAlreadyRead: "Diary already read",
    diaryReviewedSubject: "Diary Reviewed",
    newDiary: "New diary",
    searchTemplatesPlaceholder: "Search by procedure, area, or questionnaire...",
    noTemplatesYet: "You have no templates yet. Create one to start inviting patients.",
    noTemplatesMatch: "No templates match your search.",
    searchTemplatesShort: "Search templates...",
    procedureFilterInjection: "Injection",
    procedureFilterSurgery: "Surgery",
    procedureFilterShockwave: "Shockwave",
    procedureFilterConsultation: "Consultation",
    procedureFilterProduct: "Product",
    checkingActiveQuestionnaires: "Checking for active questionnaires...",
    stopQuestionnairesDescription: "Stop any questionnaires before adding a new one, or continue with all active.",
    noActiveQuestionnairesDescription: "No active questionnaires. Continue to add a new one.",
    stopping: "Stopping...",
    stopAllCurrentQuestionnaires: "Stop All Current Questionnaires",
    stopOnly: (name) => `Stop ${name} Only`,
    stopJoined: (list) => `Stop ${list}`,
    stopTrackerAria: (name) => `Stop ${name}`,
    checkingActiveBeforeTemplate: "Checking for active questionnaires before you confirm the template…",
    templateExistingTrackersDescription:
        "Tick any you want to stop before adding from this template, or continue with all active questionnaires.",
    newPatientDiary: "New patient diary",
    newPatientDiaryDescription: "Choose a template, review the setup, then invite your patient.",
    createTemplate: "Create a template",
    favourites: "Favorites",
    allTemplates: "All templates",
    needFiltersHint: "Need filters or to manage templates?",
    browseAllTemplates: "Browse all templates",
    cc: "Cc",
    saving: "Saving…",
    interventionTypeQuestion: "What type of intervention?",
    selectInterventionRequired: "Please select an intervention type",
    questionnairesLabel: "Questionnaires",
    continueLabel: "Continue",
    notifyPatientUpdatedDescription:
        "The template has been added to the diary. Would you like to send the patient a message about the update?",
    noJustFinish: "No, just finish",
    yesNotifyPatient: "Yes, notify patient",
    diaryUpdatedFromTemplate: "Diary updated from template",
    couldNotApplyTemplate: "Could not apply template",
    updateMessageTitle: "Message Patient?",
    updateMessageDescription: "Send a message to the patient after saving.",
    noJustSave: "No, just save",
    yesSendMessage: "Yes, send a message",
    saveAndMessagePatient: "Save & Message Patient",
    saveOnly: "Save",
    updateQuestionnairesTitle: "Questionnaires",
    updateQuestionnairesDescription: "Select questionnaires and schedules for tracking",
    selectQuestionnaire: "Select Questionnaire",
    selectQuestionnaireHelp: "What questions should the patient answer?",
    selectSchedule: "Select Schedule",
    selectScheduleHelp: "When should the patient complete the questionnaire?",
    addAnotherQuestionnaire: "Add Another Questionnaire",
    continueWithoutQuestionnaires: "Continue without questionnaires",
    referenceDateTitle: "Date",
    referenceDateDescription: "Set the date the treatment or tracking period begins.",
    contactStepDescription: "Who is the contact person?",
    questionnaireWithIndex: (index: number) => `Questionnaire ${index}`,
    setFlag: "Set flag",
    editStatus: "Edit status",
    setFlagTitle: "Edit status",
    setFlagDescription: "This replaces the automatic status until you hand the diary back.",
    flagOnTrack: "On track",
    flagImproved: "Improved",
    flagWorsening: "Worsening again",
    flagNotImproving: "Not improving",
    flagNoteLabel: "Note",
    flagNotePlaceholder: "Optional internal note",
    saveFlag: "Save status",
    resumeAutomatic: "Resume automatic status",
    resumeAutomaticHint: "The status will be calculated again from the patient's entries.",
    setManually: "Set manually",
    setManuallyBy: (name) => `Set by ${name}`,
    teamRecordTitle: "Team record",
    teamRecordPrivate: "Only visible to clinicians and admins. Patients never see this.",
    notesTitle: "Notes (not shared with patient)",
    notesDescription: "Internal notes (not shared with patient)",
    noteByline: (author, when) => `By ${author} ${when}`,
    noteJustNow: "now",
    addNote: "Add note",
    notePlaceholder: "Write an internal note",
    saveNote: "Save note",
    editNote: "Edit",
    addNoteName: "Add a name",
    noteNameLabel: "Name",
    saveNoteEdit: "Save",
    deleteNote: "Delete",
    deleteNoteTitle: "Delete note",
    deleteNoteConfirm: "This note will be removed. This cannot be undone.",
    noteDeleted: "Note deleted",
    couldNotDeleteNote: "Could not delete the note",
    cancelNoteEdit: "Cancel",
    noteEdited: "Edited",
    statusChangedTo: "Status changed to",
    statusSetVerb: "set",
    statusResumed: (name) => `${name} returned this diary to automatic status`,
    noTeamRecord: "No status changes yet.",
    couldNotSaveFlag: "Could not save the flag",
    couldNotSaveNote: "Could not save the note",
    flagSaved: "Flag saved",
    noteSaved: "Note saved",
};
